import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Notificacion } from '@/app/models/interface/notificacion.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class NotificacionService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'notificacion/';

  findLatestNotifications(params: HttpParams) {
    const dir = this.url + 'findLatestNotifications';
    return this.http
      .get<CustomResponse<{ data: Notificacion[]; count: number }>>(dir, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findAll(params: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<Notificacion[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  update(id: string, data: Partial<Notificacion>) {
    const dir = this.url + id;
    return this.http.patch<CustomResponse<Notificacion>>(dir, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }
}
